import API from "helpers/api";
import { BASE_API_PATH } from "helpers/constants";

const ENDPOINT = `${BASE_API_PATH}reports/generate`;

const ok = (response) => ({
	status: response?.status >= 200 && response?.status < 300,
	data: response?.data,
});

// POST /api/reports/generate - fires a one-shot "generate this report and
// email me a download link when it's ready" request. The API returns
// 202 Accepted immediately; the user gets the email once the worker
// finishes rendering and uploading.
//
// The backend renders report dates in filterContext.timeZone and falls back
// to the user's profile timezone, then UTC (ReportContext.ResolveTimeZone).
// Profile timezone is rarely set, so stamp the browser timezone on every
// request (callers may still override it) to keep report dates consistent
// with what the web app shows on screen.
export const generateReportNow = async (body) => {
	try {
		const filterContext = {
			...body?.filterContext,
			timeZone:
				body?.filterContext?.timeZone ??
				Intl.DateTimeFormat().resolvedOptions().timeZone,
		};
		return ok(await API.post(ENDPOINT, { ...body, filterContext }));
	} catch (err) {
		return ok(err?.response);
	}
};
